import { useEffect } from "react";
import { gsap } from "gsap";

interface BlinkingAnimationProps {
    svgElement: SVGElement;
    animationSpeed: number;
  }
const BlinkingAnimation: React.FC<BlinkingAnimationProps> = ({ svgElement, animationSpeed }) => {
  useEffect(() => {
    const elements = svgElement.querySelectorAll("circle, rect");

    gsap.to(svgElement, {
      opacity: 0,
      duration: animationSpeed,
      repeat: -1,
      yoyo: true,
      ease: "power2.inOut",
    });
  }, [svgElement, animationSpeed]);

  return null;
};

export default BlinkingAnimation;
